import axios from 'axios/index';
import {showProfileLockedWarning} from '../utility/showProfileLockedWarning';

export default {
  methods: {
    linkRedtailAccount() {
      showProfileLockedWarning.warning(this.profileLocked).then(() => {
        return false;
      });

      let self = this;
      this.formParams = this.buildFormParams('linkRedtailAccount');
      const error = 'There was an error processing your request. Please try again later.';

      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          self.processing = true;
          axios
            .post('/api/?entity=vessel&action=linkRedtailToVessel', self.formParams)
            .then(() => {
              axios
                .get('/api/?entity=vessel&action=getRedtailIntegration')
                .then(response => {
                  let redtail = response.data;

                  if (response !== false) {
                    this.userKey = redtail.user_key;
                    this.processing = false;
                  }
                })
                .catch(() => {
                  this.processing = false;
                });
            })
            .catch(() => {
              this.error = 'The username and password combination you provided was incorrect. Please try again.';
              this.processing = false;
            });
        }
      });
    },
  },
};
